import type {PropsWithChildren} from 'react'
import type {CustomGoSchoolConfig} from '@goschool/model'
import {CustomGoSchoolContext} from '@goschool/model'


export type CustomGoSchoolContextProviderProps = PropsWithChildren & CustomGoSchoolConfig

export function CustomGoSchoolContextProvider(props: CustomGoSchoolContextProviderProps) {
  const {children, ...config} = props
  return <CustomGoSchoolContext.Provider value={config}>{children}</CustomGoSchoolContext.Provider>
}

